module.exports = {"150902001":"新体路街道","150902002":"桥东街道","150902003":"前进路街道","150902004":"常青街道","150902005":"虎山街道","150902006":"桥西街道","150902007":"新华街街道","150902008":"泉山街道","150902105":"白海子镇","150902205":"马莲渠乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150902.json
// module id = 554
// module chunks = 0